import axios from './axiosInstances/axiosInstance';

export const getGroupOrder = (groupOrderId) => {
  return axios.get(`/baskets/grouporders/${groupOrderId}`);
};
